import { render, staticRenderFns } from "./UsersIAmAuthorizedOn.vue?vue&type=template&id=1060190e&"
import script from "./UsersIAmAuthorizedOn.vue?vue&type=script&lang=js&"
export * from "./UsersIAmAuthorizedOn.vue?vue&type=script&lang=js&"
import style0 from "./UsersIAmAuthorizedOn.vue?vue&type=style&index=0&id=1060190e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports